import { render, staticRenderFns } from "./fire-quick-detail.vue?vue&type=template&id=374c66ec&scoped=true&"
import script from "./fire-quick-detail.vue?vue&type=script&lang=js&"
export * from "./fire-quick-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c66ec",
  null
  
)

export default component.exports